export default {"src":"/_next/static/media/design-talent.ca247b0d.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};